import ActStatusCircle from "../../../UIElements/StatusCircle";
import EnumsContext from "../../../../context/enums-context";
import { formatCurrency, useEnumLabel } from "../../../../Utils/Utils";
import { Translate } from "../../../../Utils/TranslationUtils";
import useApi from "../../../../Utils/BackendClient";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import { Button } from "primereact/button";
import { Chip } from "primereact/chip";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { SplitButton } from "primereact/splitbutton";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";

import commonStyle from "../../CommonStyles.module.css";
import PaymentSideBar from "../../../UIElements/Sidebars/PaymentSidebar";
import DocumentPrintSidebar from "../../../UIElements/DocumentPrintSidebar";
import DocumentArchive from "../../../UIElements/DocumentArchive";
import DropDownTemplate from "../../../UIElements/FilterTemplates/DropDownTemplate";


const ProductsReturn = () => {

    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const location = useLocation();
    const buttonRef = useRef(null);
    const toast = useRef(null);
    const ctx = useContext(EnumsContext);
    const { deleteClientReturnAct, fetchClientReturnActs, fetchClientReturnActDocuments, finalizeClientReturnAct } = useApi();

    const enumTypes = useMemo(() => ["divisions", "clients", "pay_statuses"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);
    const getClientLabel = useEnumLabel(ctx.enums.clients.data);
    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);

    const [docArchive, setDocArchive] = useState(null);
    const [docArchiveSidebarVisible, setDocArchiveSidebarVisible] = useState(false);
    const [docArchiveTotalRecords, setDocArchiveTotalRecords] = useState(0);
    const [docPrintSidebarVisible, setDocPrintSidebarVisible] = useState(false);
    const [loading, setLoading] = useState(true);
    const [productReturnActs, setProductReturnActs] = useState([]);
    const [reloadData, setReloadData] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [visible, setVisible] = useState(false);
    const [lazyState, setlazyState] = useState({
        first: 0,
        rows: 10,
        page: 1,
        sortField: "created_at",
        sortOrder: 1,
        filters: {
            cagent: { value: null, matchMode: 'contains' },
            division: { value: null, matchMode: 'contains' },
            pay_status: { value: null, matchMode: 'contains' }
        }
    });
    const [docArchiveLazyState, setDocArchiveLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [tableFilters, setTableFilters] = useState({
        cagent: { value: null, matchMode: 'contains' },
        division: { value: null, matchMode: 'contains' },
        pay_status: { value: null, matchMode: 'contains' }
    });

    const showToast = (msg) => {
        toast.current.show(msg);
    }

    useEffect(() => {
        if (location.state?.toast) {
            showToast(location.state.toast);

            location.state.toast = null;
            navigate(location.pathname, { replace: true, state: location.state });
        }
    }, [location, navigate]);

    useEffect(() => {

        const getClientsReturns = async () => {

            let state = lazyState;

            if(location.state?.pageState){

                state = location.state?.pageState;
                setlazyState(location.state?.pageState);

                location.state.pageState = null;

                navigate(location.pathname, { replace: true, state: location.state });
            }

            const response = await fetchClientReturnActs(state);

            if (response.status === 200) {
                setTotalRecords(response.data.count);
                setProductReturnActs(response.data.results);
            }
            else {
                if (response.status === 403) {
                    toast.current.show({ severity: "error", summary: "Помилка завантаження списку повернень", detail: "Користувач не має права переглядати сторінку", life: 3000 });
                }
                else {
                    toast.current.show({ severity: "error", summary: "Помилка завантаження списку повернень", detail: "Помилкв сервера: " + response.status, life: 3000 });
                }
            }

            setLoading(false);
        }

        getClientsReturns();

    }, [lazyState, location, navigate, reloadData, fetchClientReturnActs]);

    const hideSidebar = () => {
        setVisible(false);
    };

    const CreateNewProductsReturnButtonHandler = () => {
        navigate("/productsreturn/newproductsreturn");
    }

    const getDocumentsArchive = async (data, lazyState) => {

        setSelectedItem(data);

        const response = await fetchClientReturnActDocuments(data.id, lazyState);

        if (response.status === 200) {
            setDocArchive(response.data.results);
            setDocArchiveTotalRecords(response.data.count);
        }
    }

    const onPage = (event) => {
        event.page = event.page + 1;
        setlazyState(event);
        console.log(event);
    };

    const onSort = (event) => {
        event.page = lazyState.page;
        setlazyState(event);
    }

    const onFilter = (event) => {
        setTableFilters(event.filters);
    }

    const onDocArchivePage = (event) => {
        event.page = event.page + 1;
        getDocumentsArchive(selectedItem, event);

        setDocArchiveLazyState(event);
    }

    const resetLazyState = () => {
        setDocArchiveLazyState({
            first: 0,
            rows: 10,
            page: 1
        })
    }

    const confirmDelete = (event, rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Підтвердіть видалення акту',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { DeleteButtonHandler(rowData) }
        });
    }

    const confirmFinalize = (event, rowData) => {
        confirmDialog({
            group: 'headless',
            header: 'Підтвердження',
            message: 'Після фіналізації акту, буде відсутня можливість його редагування',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            defaultFocus: 'accept',
            accept: () => { FinalizeActHandler(rowData) }
        });
    }

    const DeleteButtonHandler = (rowData) => {
        const deleteAct = async () => {

            const response = await deleteClientReturnAct(rowData.id);
            //logging to remove later
            console.log(response);

            if (response.status !== 204) {
                toast.current.show({ severity: "error", summary: "Помилка видалення", detail: "Помилка сервера " + response.status, life: 3000 });
            }
            else {
                toast.current.show({ severity: "success", summary: 'Видалення', detail: 'Акт успішно видалено', life: 3000 });
            }

            setReloadData(!reloadData);
        }

        deleteAct();
    }

    const FinalizeActHandler = (rowData) => {

        const finalizeAct = async () => {

            const response = await finalizeClientReturnAct(rowData.id);

            if (response.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Фіналізація', detail: 'Акт фіналізовано', life: 3000 });
            }
            else if (response.status === 404) {
                toast.current.show({ severity: "error", summary: "Помилка фіналізації", detail: "Акту " + rowData.id + " не знайдено", life: 3000 });
            }
            else if (response.status === 405) {
                toast.current.show({ severity: "error", summary: "Помилка фіналізації", detail: "Акт " + rowData.id + " уже фіналізовано", life: 3000 });
            }
            else {
                toast.current.show({ severity: "error", summary: "Помилка фіналізації", detail: "Помилка сервера " + response.status, life: 3000 });
            }

            setReloadData(!reloadData);
        }

        finalizeAct();
    }

    const PaymenButtonHandler = (rowData) => {

        setSelectedItem(rowData);
        setVisible(true);
    }

    const filterApply = () => {
        const editedLazyState = lazyState;
        editedLazyState.page = 1;
        editedLazyState.filters = tableFilters;
        setlazyState(editedLazyState);
        setReloadData(!reloadData)
    }

    const clearFilter = (paramName, value) => {
        setlazyState(prevState => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                [paramName]: {
                    ...prevState.filters[paramName],
                    value: value
                }
            }
        }));
    }

    const clearFilterFromChips = (paramName, value) => {
        clearFilter(paramName, value);
        setTableFilters(prevState => ({
            ...prevState,
            [paramName]: {
                value: value
            }
        }));
    }

    const formatFilterChips = () => {

        const getChangedValue = (filterKey, value) => {
            if (filterKey === "cagent") {
                return getClientLabel(value);
            }
            else if (filterKey === "division") {
                return getDivisionLabel(value);
            }
            else if (filterKey === "pay_status") {
                return getPayStatusLabel(value);
            }

            return value;
        };

        return (
            <div className="flex flex-wrap gap-2">
                {Object.keys(lazyState.filters).map((filterKey) => {
                    const filter = lazyState.filters[filterKey];

                    if (filter.value && filter.value !== "") {
                        const translatedKey = filterKey === "cagent" ? "Клієнт" : Translate(filterKey);
                        const changedValue = getChangedValue(filterKey, filter.value);

                        return (
                            <Chip
                                key={filterKey}
                                label={`${translatedKey}: ${changedValue}`}
                                removable
                                onRemove={() => clearFilterFromChips(filterKey, null)}
                            />
                        );
                    }
                    return null;
                })}
            </div>
        );
    };

    const handleMobileFilterChange = (key, value) => {
        setTableFilters((prevFilters) => ({
            ...prevFilters,
            [key]: { ...prevFilters[key], value: value }
        }));
    }

    const clearMobileFilters = () => {
        setTableFilters({
            cagent: { value: null, matchMode: 'contains' },
            division: { value: null, matchMode: 'contains' },
            pay_status: { value: null, matchMode: 'contains' }
        });

        setlazyState(prevState => ({
            ...prevState,
            filters: {
                cagent: { value: null, matchMode: 'contains' },
                division: { value: null, matchMode: 'contains' },
                pay_status: { value: null, matchMode: 'contains' }
            }
        }));
    }

    const tableHeader = (
        <div className="flex justify-content-between align-items-center w-full">
            {formatFilterChips()}
        </div>
    );

    const EditReturnActHandler = rowData => {
        const route = '/productsreturn/editproductsreturn/' + rowData.id;
        navigate(route, { state: { id: rowData.id, pageState: lazyState } });
    }

    const formatAdditionalButtons = (rowData) => {

        let buttons = [];
        if (rowData.status !== "FINALIZED") {
            buttons.push({
                label: 'Фіналізувати',
                icon: 'pi pi-lock',
                command: (event) => { confirmFinalize(event, rowData) }
            });
        }
        else {
            if (rowData.pay_status !== "PAYED") {
                buttons.push({
                    label: 'Оплатити',
                    icon: 'pi pi-money-bill',
                    command: () => { PaymenButtonHandler(rowData) }
                });
            }
        }

        if (rowData.can_be_deleted) {
            buttons.push({
                label: 'Видалити',
                icon: 'pi pi-trash',
                command: (event) => { confirmDelete(event, rowData) }
            });
        }

        if (rowData.templates?.length > 0) {
            buttons.push({
                label: 'Друкувати документи',
                icon: 'pi pi-print',
                command: () => {
                    setDocPrintSidebarVisible(true)
                    setSelectedItem(rowData);
                }
            });
        }

        buttons.push({
            label: 'Архів документів',
            icon: 'pi pi-save',
            command: () => {
                getDocumentsArchive(rowData, docArchiveLazyState);
                setDocArchiveSidebarVisible(true)
            }
        });

        buttons = buttons.length > 0 ? buttons : null;
        return buttons
    };

    const actionBodyTemplate = (rowData) => {
        const buttons = formatAdditionalButtons(rowData);

        const buttonLabel = rowData.status !== "FINALIZED" ? "Редагувати" : "Деталі акту";
        const buttonIcon = rowData.status !== "FINALIZED" ? "pi pi-pencil" : "pi pi-eye";

        return (
            <SplitButton
                label={!isMobile ? buttonLabel : null}
                icon={buttonIcon}
                onClick={() => EditReturnActHandler(rowData)}
                model={buttons}
                text
                ref={buttonRef} // Set the ref here
            />
        );
    };

    const toolbarLeftTemplate = () => {
        return (isMobile && <Button icon={`${!showFilters ? "pi pi-filter" : "pi pi-filter-slash"}`} severity="secondary" outlined onClick={() => setShowFilters(!showFilters)} />)
    }

    const toolbarRightTemplate = () => {
        return (<div className="flex flex-wrap gap-2">
            <Button label="Додати акт повернення товару" severity="success" className={commonStyle.addButton} onClick={CreateNewProductsReturnButtonHandler} />
        </div>)
    }

    const mobileActBody = rowData => {

        const color = rowData.pay_status === "PAYED" ? "#03C04A" : "#EF4444";

        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-2 flex justify-content-center align-items-center">
                        <ActStatusCircle rowData={rowData} />
                    </div>
                    <div className="col-10">
                        <div className="flex-column">
                            <div>Акт №{rowData.act_number}</div>
                            <div><i className="pi pi-clock" /> {rowData.act_date}</div>
                            <div style={{ color }}><i className={`pi ${rowData.pay_status === "PAYED" ? "pi-check" : "pi-times"}`} /> {getPayStatusLabel(rowData.pay_status)}</div>
                            <div><i className="pi pi-user" /> {getClientLabel(rowData.cagent) ?? "Клієнта не вказано"}</div>
                            <div><i className="pi pi-money-bill" /> {formatCurrency(rowData.amountUAH, "UAH")}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {actionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    const mobileTableHeader = () => {
        return (
            showFilters && <div className="grid">
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={tableFilters.cagent.value}
                            onChange={e => handleMobileFilterChange("cagent", e.value)}
                            options={ctx.enums.clients.data}
                            placeholder="Виберіть значення"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Клієнт</label>
                    </FloatLabel>
                </div>
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={tableFilters.pay_status.value}
                            onChange={e => handleMobileFilterChange("pay_status", e.value)}
                            options={ctx.enums.pay_statuses.data}
                            placeholder="Виберіть значення"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Статус оплати</label>
                    </FloatLabel>
                </div>
                <div className="col-6 flex justify-content-center">
                    <Button severity="secondary" outlined style={{ width: "98%" }} onClick={() => clearMobileFilters()} label="Очистити фільтри" />
                </div>
                <div className="col-6 flex justify-content-center">
                    <Button severity="success" outlined style={{ width: "98%" }} onClick={() => filterApply()} label="Застосувати" />
                </div>
            </div>
        );
    }

    return (<>
        <Toast ref={toast} />
        <Toolbar start={toolbarLeftTemplate} end={toolbarRightTemplate}></Toolbar>
        <div className='grid'>
            <div className='col-12 justify-content-center'>
                {!isMobile && <DataTable value={productReturnActs} header={tableHeader} stripedRows lazy rows={lazyState.rows} onPage={onPage} loading={loading} first={lazyState.first} onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                    dataKey="id" onFilter={onFilter} filters={lazyState.filters} emptyMessage="Актів повернення не знайдено" paginator totalRecords={totalRecords} rowsPerPageOptions={[10, 20]}>
                    <Column field="act_number" header="Номер акту" sortable style={{ width: '10%' }} />
                    <Column field="act_date" dataType="date" header="Дата акту" style={{ width: '10%' }} />
                    <Column field="division" header="Точка продажу" sortable filter filterElement={(options) => DropDownTemplate(options, ctx.enums.divisions.data)} onFilterApplyClick={filterApply}
                        onFilterClear={() => clearFilter("division", null)} showFilterMatchModes={false} body={rowData => getDivisionLabel(rowData.division)} style={{ width: '10%' }} />
                    <Column field="cagent" header="Клієнт" sortable filter filterElement={(options) => DropDownTemplate(options, ctx.enums.clients.data)} onFilterApplyClick={filterApply}
                        onFilterClear={() => clearFilter("cagent", null)} showFilterMatchModes={false} body={rowData => getClientLabel(rowData.cagent)} style={{ width: '20%' }} />
                    <Column field="amountUAH" header="Сума, грн" body={rowData => formatCurrency(rowData.amountUAH, "UAH")} sortable style={{ width: '15%' }} />
                    <Column field="pay_status" header="Оплачено" filter filterElement={(options) => DropDownTemplate(options, ctx.enums.pay_statuses.data)} onFilterApplyClick={filterApply}
                        onFilterClear={() => clearFilter("pay_status", null)} showFilterMatchModes={false} body={rowData => getPayStatusLabel(rowData.pay_status)} style={{ width: '15%' }} />
                    <Column field="status" header="Статус" body={rowData => <ActStatusCircle rowData={rowData} />} sortable style={{ width: '5%' }} />
                    <Column field="action" body={actionBodyTemplate} style={{ width: '15%' }} />
                </DataTable>}
                {isMobile && <DataTable value={productReturnActs} header={mobileTableHeader} stripedRows lazy rows={lazyState.rows} paginator onPage={onPage} onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
                    first={lazyState.first} loading={loading} totalRecords={totalRecords} rowsPerPageOptions={[10, 20, 50]} paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                    dataKey="id" onFilter={onFilter} filters={lazyState.filters} emptyMessage="Актів не знайдено" >
                    <Column field="act_number" headerStyle={{ display: 'none' }} body={mobileActBody} />
                </DataTable>}
            </div>
            <ConfirmDialog group="headless" />
        </div>
        <PaymentSideBar visible={visible} onHide={hideSidebar} onMessage={showToast} data={selectedItem} moneyMovementType="OUTCOME" reloadData={() => setReloadData(!reloadData)} />
        <DocumentPrintSidebar sbVisible={docPrintSidebarVisible} onHide={() => setDocPrintSidebarVisible(false)} actData={selectedItem} toast={toast} />
        <DocumentArchive sbVisible={docArchiveSidebarVisible} onHide={() => { setDocArchiveSidebarVisible(false); resetLazyState(); }}
            documents={docArchive} lazyState={docArchiveLazyState} onPage={onDocArchivePage} totalRecords={docArchiveTotalRecords} toast={toast} />
    </>);
}

export default ProductsReturn;